import OlGeomPoint from 'ol/geom/Point'
import LayerGroup from 'ol/layer/Group'
import Buffer from '../../../plugins/layers/vector/Buffer'
import Selection from '../../../plugins/layers/vector/Selection'
import { FEATURE_INFO, SELECTED_FEATURE_POINT } from '../../../plugins/utils/styles/styles'

export default class GetFeatureInfoLayer extends LayerGroup {
  constructor (map) {
    super()
    
    const layerCollection = this.getLayers()
    
    this.geojson = map.getGeoJSONParser()
    
    this.selectionLayer = new Selection()
    layerCollection.push(this.selectionLayer)

    this.bufferLayer = new Buffer({ style: FEATURE_INFO })
    layerCollection.push(this.bufferLayer)

    this.map = map
    this.previousView = undefined
  }

  setBuffer(coordinate) {
    this.bufferLayer.drawGeometry(new OlGeomPoint(coordinate))
  }

  removeBuffer() {
    this.bufferLayer.clear()
  }

  setGeoJSONSelection(geoJSONFeature, needZoom = false) {
    this.selectionLayer.clear()
    if (geoJSONFeature) {
      const olFeature = this.geojson.readFeature(geoJSONFeature)
      this.setSelection(olFeature)
      if (needZoom) {
        const view = this.map.getView()
        if (!this.previousView) this.previousView = { zoom: view.getZoom(), center: view.getCenter(), duration: 500 }
        view.fit(olFeature.getGeometry(), { size: this.map.getSize(), duration: 500 })
      }
    } else {
      this.restoreView()
    }
  }

  setSelection(feature) {
    const layerColor = localStorage.getItem('layerColor') || 'DAY'
    this.selectionLayer.setStyle(SELECTED_FEATURE_POINT[layerColor])
    this.selectionLayer.drawFeature(feature)
    this.selectionLayer.setVisible(true)
  }

  updateSelectedColor() {
    const layerColor = localStorage.getItem('layerColor') || 'DAY'
    this.selectionLayer.setStyle(SELECTED_FEATURE_POINT[layerColor])
  }

  restoreView() {
    if (this.previousView) {
      this.map.getView().animate(this.previousView)
      this.previousView = undefined
    }
  }

  clear() {
    this.restoreView()
    this.bufferLayer.clear()
    this.selectionLayer.clear()
  }
}